import * as React from 'react';
import { CreatePost } from 'features/DigitalMarketing/pages/CreatePost';

type CreatePostRoute = {
  subPath?: string;
  element: React.ReactElement;
};

export const CREATE_POST_ROUTES: CreatePostRoute[] = [
  { element: <CreatePost /> },
  { subPath: 'create', element: <CreatePost /> },
  { subPath: 'edit/:postId', element: <CreatePost /> },
  { subPath: 'preview/:postId', element: <CreatePost /> },
];

export const CREATE_POST_SUB_ROUTES = CREATE_POST_ROUTES.map(route => ({
  path: route.subPath ? `posted-content/${route.subPath}` : 'posted-content',
  element: route.element,
}));
